import React from 'react';
import { Datagrid, ListContextProvider } from 'react-admin';

import { CssRowFieldCellWrapper } from '../fields/CssFieldCellWrapper';
import { ScrollingWrapper } from '../ScrollingWrapper';

export const HighlightList = ({value, children, cssFnRow, Actions, sharedFieldsProps = {} }) => (
	value ? (
		<ListContextProvider value={value}>
			{Actions && React.cloneElement(Actions)}
			<div style={{ maxHeight: Actions ? "75vh": "100vh", overflow: "auto"}}>
				<ScrollingWrapper>
					<Datagrid size="small" rowClick={null} hover={false} optimized={false}>
						<CssRowFieldCellWrapper cssFn={cssFnRow} />
						{React.Children.map(
							children, 
							(child) => React.cloneElement(child, {...child.props, sharedFieldsProps})
						)}
					</Datagrid>
				</ScrollingWrapper>
			</div>
		</ListContextProvider>
		) 
	: <></>
);
